<template>
  <title>0LP | Graphic Design</title>
    <link rel="stylesheet" href="\css\graphicdesign.css">
    <body>
      <div class="graphicdesign-title-container">
        <a href="/" ><img class="logo" src="/images/logo/logo_crp.png" ></a>

        <h3>Graphic Design Gallery</h3>
      </div>
        <div class="full-img" v-if="isFullImgBoxVisible">
      <img :src="fullImgSrc" id="fullImg">
      <span @click.stop="closeFullImg">X</span>
    </div>

    <div class="img-gallery">
      <img v-for="(g_design, index) in gDesigns" :key="index" v-bind:src="g_design.path" :alt="g_design.name" @click="openFullImg(g_design.path)" >
    </div>

    </body>
</template>
<script>
// import axios from 'axios';
export default{
    
    name: 'GraphicDesigning',
    data() {
        return {
            isFullImgBoxVisible: false,
            fullImgSrc: '',
            gDesigns: [],
        }
    },
    created() {
        this.fetchGDesign();
    },
    methods:{
        async fetchGDesign() {
            try {
            // const response = await axios.get(`${process.env.BACKEND_APP_API_BASE_URL}/api/portfolio/graphicdesigning`);
            const response = [
              {
                id: 70,
                title: 'REVEALING POST',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/RFp4tm0k/REVEALING-POST.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 69,
                title: 'FEATURES POST',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/4dJrwSMX/FEATURES-POST.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 67,
                title: 'CALL TO ACTION POST 1',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/BnPs1RWy/CALL-TO-ACTION-POST-1.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 65,
                title: 'teaser 03',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/1zWg5LDd/teaser-03.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 64,
                title: 'NCD CAR RACE - City contest creative',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/85t7cxW3/NCD-CAR-RACE-City-contest-creative.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 62,
                title: 'NCD CAR RACE',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/W3M7yNBZ/NCD-CAR-RACE.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 30,
                title: '',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/nhWbF2Ck/teaser-16.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 30,
                title: '',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/gkP0dYfJ/teaser-15.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 30,
                title: '',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/63kp8wqM/teaser-04.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 60,
                title: '10',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/sDBrGb7W/10.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 59,
                title: '9',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/rFz8CDXK/9.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 57,
                title: '8',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/4db3MqBy/8.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 55,
                title: '3',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/xj3kFJ45/3.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 54,
                title: '12',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/gjnfR6Xp/12.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 52,
                title: '1',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/9M34sG28/1.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 50,
                title: 'GSHOCK WATCH 3',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/zXy43VZQ/GSHOCK-WATCH-3.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 49,
                title: 'GSHOCK WARCH 2',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/L4CrHj7f/GSHOCK-WATCH-2.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 47,
                title: 'GSHOCK WARCH 1',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/KjzwPYKR/GSHOCK-WATCH-1.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 45,
                title: 'face illsutration 3',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/bNsvCcR3/face-illustration-3.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 44,
                title: 'face illsutration',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/nVdzGcqX/face-illsutration.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 42,
                title: 'conceptual poster',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/0jr9BD7b/conceptual-poster.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 40,
                title: 'chromed posters flies',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/Gh54dhpW/chromed-posters-flies.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 39,
                title: '',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/nVwFQSt7/face-poster.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 38,
                title: '',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/1zHPRJH8/illustration-2.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 37,
                title: '',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/qMhkcckF/LOST1.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 30,
                title: '',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/W3Psw0jt/pablo.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 30,
                title: '',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/HWzTbJNs/poster-making.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 30,
                title: '',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/ZKDZDGZG/poster-making-1.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 30,
                title: '',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/HLwqHRDs/retro-poster.jpg',
                type: 'image',
                video_code: null
              },
              {
                id: 30,
                title: '',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/BbzcLjDd/NDTVMarthi-Outdoor-Banner-KV001-1-X1.png',
                type: 'image',
                video_code: null
              },
              {
                id: 30,
                title: '',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/RVfX6Tsd/NDTVMarthi-Outdoor-Banner-KV001-1-X2.png',
                type: 'image',
                video_code: null
              },
              {
                id: 30,
                title: '',
                category: 'graphic_designing',
                path: 'https://i.postimg.cc/nLL4kKk6/NDTVMarthi-Outdoor-Banner-KV001-2x1.png',
                type: 'image',
                video_code: null
              },
              
            ];
            this.gDesigns = response;
            } catch (error) {
              console.error('Error fetching designss:', error);
              
            }
        },
        openFullImg(image) {
      // console.log('Opening full image', image);
      this.isFullImgBoxVisible = true;
      this.fullImgSrc = image;
    },
    closeFullImg() {
      // console.log('Closing full image');
      this.isFullImgBoxVisible = false;
    }

    }
}

</script>